import { render, staticRenderFns } from "./sync.vue?vue&type=template&id=6d86a1bb&scoped=true&"
import script from "./sync.vue?vue&type=script&lang=js&"
export * from "./sync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d86a1bb",
  null
  
)

export default component.exports